import React from 'react';
import { connect } from 'react-redux';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import { Button, TextField, Snackbar } from '@material-ui/core';
import AddNewEntityModal from './AddNewEntityModal';
import axios from 'axios';
import MuiAlert from '@material-ui/lab/Alert';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import LaborDetails from './LaborDetails';
import { withStyles } from '@material-ui/core/styles';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography';
import { VARIABLE_DEFINITIONS } from '../QuickMtcProposal/utils/proposalVariables';

const Accordion = withStyles({
  root: {
    border: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
  },
  expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    backgroundColor: 'rgba(0, 0, 0, .03)',
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    marginBottom: -1,
    minHeight: 56,
    '&$expanded': {
      minHeight: 56,
    },
  },
  content: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    display: 'block',
  },
}))(MuiAccordionDetails);

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2),
    minHeight: '75vh',
    padding: 10,
    margin: 10
  },
  entityContainer: {
    margin: 10,
    borderRadius: 8,
    border: '3px solid #aaa',
    padding: 10
  },
  logo: {
    margin: '5px',
    padding: '5px',
    maxWidth: 150,
    maxHeight: 110
  }
}));

const defaultStateValue = {
  showNewEntityModal: false,
  dataToUpdate: [],
  snackbarOpen: false,
  snackbarMessage: '',
  snackbarSeverity: 'success'
};

const Entities = (props) => {
  const classes = useStyles();
  const [state, setState] = React.useState(defaultStateValue);
  const [entities, setEntities] = React.useState([]);

  const fetchEntities = async () => {
    const resp = await axios.get(`${props.url}/api/entities/list`);
    setEntities(resp.data);
  };
  
  React.useEffect(() => {
    fetchEntities();
  }, []);

  const handleUpdateFromNewEntityModal = () => {
    setState({...state, showNewEntityModal: false});
  };

  const handleCloseNewEntModal = () => {
    setState({...state, showNewEntityModal: false});
  };

  const handleFocus = (event) => event.target.select();

  const handleSave = async () => {
    try {
      await axios.post(`${props.url}/api/entities/update`, state.dataToUpdate);
      setState(prev => ({
        ...prev,
        dataToUpdate: [],
        snackbarOpen: true,
        snackbarMessage: 'Entity changes saved successfully!',
        snackbarSeverity: 'success'
      }));
      await fetchEntities();
    } catch (error) {
      console.error('Error saving entities:', error);
      setState(prev => ({
        ...prev,
        snackbarOpen: true,
        snackbarMessage: 'Error saving changes: ' + (error.response?.data?.message || error.message),
        snackbarSeverity: 'error'
      }));
    }
  };

  const handleCloseSnackbar = () => {
    setState(prev => ({ ...prev, snackbarOpen: false }));
  };


  const updateOurDataToUpdate = (passedData) => {
    const { entityId, data } = passedData;

    setState(prevState => {
      const existingDataToUpdate = [...(prevState.dataToUpdate || [])];
      const existingIndex = existingDataToUpdate.findIndex(item => item._id === entityId);

      if (existingIndex > -1) {
        // Merge new data with existing data
        const existingData = existingDataToUpdate[existingIndex].updatedData;
        const mergedData = mergeDeep(existingData, data);
        
        existingDataToUpdate[existingIndex] = {
          _id: entityId,
          updatedData: mergedData
        };
      } else {
        existingDataToUpdate.push({
          _id: entityId,
          updatedData: data
        });
      }

      return {
        ...prevState,
        dataToUpdate: existingDataToUpdate
      };
    });
  };

  const mergeDeep = (target, source) => {
    const output = { ...target };
    
    if (isObject(target) && isObject(source)) {
      Object.keys(source).forEach(key => {
        if (isObject(source[key])) {
          if (!(key in target)) {
            Object.assign(output, { [key]: source[key] });
          } else {
            output[key] = mergeDeep(target[key], source[key]);
          }
        } else {
          Object.assign(output, { [key]: source[key] });
        }
      });
    }
    return output;
  };

  const isObject = (item) => {
    return item && typeof item === 'object' && !Array.isArray(item);
  };

  const updateOurEntity = (passedData) => {
    const { entityId, data } = passedData;
    
    setEntities(prevEntities => 
      prevEntities.map(entity => {
        if (entity._id === entityId) {
          return mergeDeep(entity, data);
        }
        return entity;
      })
    );

    updateOurDataToUpdate(passedData);
  };


  const renderEntityFields = (item, handleChange) => (
    <Grid container spacing={2} style={{padding: '10px'}}>
      <Grid item lg={2} md={3} sm={4} xs={12}>
        <TextField
          variant="outlined"
          fullWidth
          id="entityNameFormal"
          onChange={handleChange}
          value={item.entityNameFormal}
          helperText={`What is the Formal Name for ${item.name}?`}
        />
      </Grid>
      <Grid item lg={2} md={3} sm={4} xs={12}>
        <TextField
          variant="outlined"
          fullWidth
          id="name"
          onChange={handleChange}
          value={item.name}
          helperText={`What is the Common Name for ${item.name}?`}
        />
      </Grid>
      <Grid item lg={2} md={3} sm={4} xs={12}>
        <TextField
          variant="outlined"
          fullWidth
          id="returnEmail"
          onChange={handleChange}
          value={item.returnEmail}
          helperText={`What is the Return Email Address for ${item.name}?`}
        />
      </Grid>
      <Grid item lg={2} md={3} sm={4} xs={12}>
        <TextField
          variant="outlined"
          fullWidth
          id="rocNumber"
          onChange={handleChange}
          value={item.rocNumber}
          helperText={`What is the ROC Number for ${item.name}?`}
        />
      </Grid>
    </Grid>
  );

  return (
    <div style={{padding: '5px', margin: '10px'}}>
      <AddNewEntityModal 
        open={state.showNewEntityModal} 
        updateParent={handleUpdateFromNewEntityModal} 
        closeModal={handleCloseNewEntModal} 
      />
      <Paper className={classes.paper}>
        <Grid container>
          <Grid item lg={6} xs={12}>
            <h1>Entities</h1>
          </Grid>
          <Grid item lg={6} xs={12}>
            <Button
              variant="contained"
              color="secondary"
              size="small"
              onClick={() => setState(prev => ({...prev, showNewEntityModal: !prev.showNewEntityModal}))}
            >
              Add New Entity
            </Button>
          </Grid>
          <Grid item lg={12} xs={12}>
            <List component="div" role="list">
              {entities.map((item, index) => {
                const handleChange = (e) => {
                  updateOurEntity({
                    data: { [e.target.id]: e.target.value },
                    entityId: item._id
                  });
                };

                const sameAsBilling =
                  (item.billingAddress || '') === (item.physicalAddress || '') &&
                  (item.billingCity || '') === (item.physicalCity || '') &&
                  (item.billingState || '') === (item.physicalState || '') &&
                  (item.billingZip || '') === (item.physicalZip || '');

                const handleBillingChange = (e) => {
                  const fieldMap = {
                    billingAddress: 'physicalAddress',
                    billingCity: 'physicalCity',
                    billingState: 'physicalState',
                    billingZip: 'physicalZip'
                  };
                  const data = { [e.target.id]: e.target.value };
                  if (sameAsBilling && fieldMap[e.target.id]) {
                    data[fieldMap[e.target.id]] = e.target.value;
                  }
                  updateOurEntity({ data, entityId: item._id });
                };

                return (
                  <div className={classes.entityContainer} key={item._id}>
                    {/* Entity Header */}
                    <ListItem role="listitem" style={{ paddingBottom: 16 }}>
                      <ListItemIcon>
                        <img
                          alt="Logo"
                          src={`${process.env.PUBLIC_URL}/${item._id}_Logo.png`}
                          className={classes.logo}
                        />
                      </ListItemIcon>
                      <ListItemText
                        primary={item.name}
                        secondary={
                          [item.billingCity, item.billingState]
                            .filter(Boolean)
                            .join(', ') || 'No address on file'
                        }
                      />
                    </ListItem>

                    {/* Section 1: General Info */}
                    <Accordion defaultExpanded>
                      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography variant="subtitle1" style={{ fontWeight: 500 }}>
                          General Info
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        {renderEntityFields(item, handleChange)}
                      </AccordionDetails>
                    </Accordion>

                    {/* Section 2: Addresses */}
                    <Accordion>
                      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography variant="subtitle1" style={{ fontWeight: 500 }}>
                          Addresses
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Grid container spacing={3}>
                          {/* Billing Address */}
                          <Grid item xs={12} md={6}>
                            <Typography variant="subtitle2" style={{ fontWeight: 500, marginBottom: 8 }}>
                              Billing Address
                            </Typography>
                            <Grid container spacing={2}>
                              <Grid item xs={12}>
                                <TextField
                                  variant="outlined"
                                  fullWidth
                                  size="small"
                                  id="billingAddress"
                                  label="Street Address"
                                  value={item.billingAddress || ''}
                                  onChange={handleBillingChange}
                                />
                              </Grid>
                              <Grid item xs={12} sm={5}>
                                <TextField
                                  variant="outlined"
                                  fullWidth
                                  size="small"
                                  id="billingCity"
                                  label="City"
                                  value={item.billingCity || ''}
                                  onChange={handleBillingChange}
                                />
                              </Grid>
                              <Grid item xs={6} sm={3}>
                                <TextField
                                  variant="outlined"
                                  fullWidth
                                  size="small"
                                  id="billingState"
                                  label="State"
                                  value={item.billingState || ''}
                                  onChange={handleBillingChange}
                                />
                              </Grid>
                              <Grid item xs={6} sm={4}>
                                <TextField
                                  variant="outlined"
                                  fullWidth
                                  size="small"
                                  id="billingZip"
                                  label="Zip"
                                  value={item.billingZip || ''}
                                  onChange={handleBillingChange}
                                />
                              </Grid>
                            </Grid>
                          </Grid>

                          {/* Physical Address */}
                          <Grid item xs={12} md={6}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
                              <Typography variant="subtitle2" style={{ fontWeight: 500 }}>
                                Physical Address
                              </Typography>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    size="small"
                                    checked={sameAsBilling}
                                    onChange={(e) => {
                                      if (e.target.checked) {
                                        updateOurEntity({
                                          entityId: item._id,
                                          data: {
                                            physicalAddress: item.billingAddress || '',
                                            physicalCity: item.billingCity || '',
                                            physicalState: item.billingState || '',
                                            physicalZip: item.billingZip || ''
                                          }
                                        });
                                      }
                                    }}
                                    color="primary"
                                  />
                                }
                                label={<Typography variant="caption">Same as Billing</Typography>}
                              />
                            </div>
                            <Grid container spacing={2}>
                              <Grid item xs={12}>
                                <TextField
                                  variant="outlined"
                                  fullWidth
                                  size="small"
                                  id="physicalAddress"
                                  label="Street Address"
                                  value={item.physicalAddress || ''}
                                  onChange={handleChange}
                                  disabled={sameAsBilling}
                                />
                              </Grid>
                              <Grid item xs={12} sm={5}>
                                <TextField
                                  variant="outlined"
                                  fullWidth
                                  size="small"
                                  id="physicalCity"
                                  label="City"
                                  value={item.physicalCity || ''}
                                  onChange={handleChange}
                                  disabled={sameAsBilling}
                                />
                              </Grid>
                              <Grid item xs={6} sm={3}>
                                <TextField
                                  variant="outlined"
                                  fullWidth
                                  size="small"
                                  id="physicalState"
                                  label="State"
                                  value={item.physicalState || ''}
                                  onChange={handleChange}
                                  disabled={sameAsBilling}
                                />
                              </Grid>
                              <Grid item xs={6} sm={4}>
                                <TextField
                                  variant="outlined"
                                  fullWidth
                                  size="small"
                                  id="physicalZip"
                                  label="Zip"
                                  value={item.physicalZip || ''}
                                  onChange={handleChange}
                                  disabled={sameAsBilling}
                                />
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </AccordionDetails>
                    </Accordion>

                    {/* Section 3: Notes */}
                    <Accordion>
                      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography variant="subtitle1" style={{ fontWeight: 500 }}>
                          Notes
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <TextField
                          variant="outlined"
                          fullWidth
                          multiline
                          minRows={4}
                          id="notes"
                          label="Entity Notes"
                          value={item.notes || ''}
                          onChange={handleChange}
                        />
                      </AccordionDetails>
                    </Accordion>

                    {/* Section 4: Labor & Equipment Rates */}
                    <Accordion>
                      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography variant="subtitle1" style={{ fontWeight: 500 }}>
                          Labor & Equipment Rates
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <LaborDetails
                          entity={item}
                          handleFocus={handleFocus}
                          updateOurEntity={updateOurEntity}
                        />
                      </AccordionDetails>
                    </Accordion>

                    {/* Section 5: Proposal Variables */}
                    <Accordion>
                      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography variant="subtitle1" style={{ fontWeight: 500 }}>
                          Proposal Variables (MTC Proposals)
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Grid container spacing={2}>
                          <Grid item xs={12}>
                            <Typography variant="caption" color="textSecondary">
                              Set default values for MTC proposal variables. These defaults will be used for all proposals created under this entity.
                            </Typography>
                          </Grid>
                          {VARIABLE_DEFINITIONS.map((varDef) => {
                            const currentValue = item.proposalVariables?.[varDef.key] ?? varDef.defaultValue

                            const handleVariableChange = (key, value) => {
                              const updated = { ...(item.proposalVariables || {}), [key]: value }
                              updateOurEntity({
                                entityId: item._id,
                                data: { proposalVariables: updated }
                              })
                            }

                            if (varDef.type === 'select') {
                              return (
                                <Grid item lg={3} md={4} sm={6} xs={12} key={varDef.key}>
                                  <TextField
                                    variant="outlined"
                                    fullWidth
                                    select
                                    size="small"
                                    label={varDef.label}
                                    value={currentValue}
                                    onChange={(e) => handleVariableChange(varDef.key, e.target.value)}
                                    SelectProps={{ native: true }}
                                  >
                                    {varDef.options.map(opt => (
                                      <option key={opt.value} value={opt.value}>{opt.label}</option>
                                    ))}
                                  </TextField>
                                </Grid>
                              )
                            }

                            return (
                              <Grid item lg={3} md={4} sm={6} xs={12} key={varDef.key}>
                                <TextField
                                  variant="outlined"
                                  fullWidth
                                  size="small"
                                  type={varDef.type === 'currency' || varDef.type === 'number' ? 'number' : 'text'}
                                  label={varDef.label}
                                  value={currentValue}
                                  onChange={(e) => handleVariableChange(varDef.key, e.target.value)}
                                  onFocus={handleFocus}
                                  inputProps={varDef.type === 'currency' || varDef.type === 'number' ? { step: varDef.type === 'currency' ? '0.01' : '1' } : {}}
                                />
                              </Grid>
                            )
                          })}
                        </Grid>
                      </AccordionDetails>
                    </Accordion>
                  </div>
                );
              })}
              {entities.length === 0 && (
                <span style={{padding: '10px', margin: 10}}>List Empty</span>
              )}
            </List>
          </Grid>
          <Grid item lg={12} xs={12}>
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={handleSave}
            >
              Save Changes
            </Button>
          </Grid>
        </Grid>
      </Paper>
      <Snackbar
        open={state.snackbarOpen}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <MuiAlert onClose={handleCloseSnackbar} severity={state.snackbarSeverity} elevation={6} variant="filled">
          {state.snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </div>
  );
};

const mapStateToProps = (state) => ({
  url: state.url,
  user: state.user,
  notification: state.notification
});

export default connect(mapStateToProps)(Entities);